export default __webpack_public_path__ + "static/media/recycle.c0fd59fc.svg";